import { Glyph, type GlyphName } from '@/components/svgs/Glyph'
import { colors } from '@/constants/colors'
import { Header } from '@/ui/core/header'
import { BlurView } from 'expo-blur'
import { View } from 'react-native'

/**
 * The brand book's blur treatment: white at 15% over a blur, a white glyph and caps. Only ever
 * on a photograph — it has nothing to blur anywhere else, and white on white is not a pill.
 */
export const PhotoBadge = ({ glyph, label }: { glyph: GlyphName; label: string }) => (
	<BlurView
		intensity={20}
		tint="light"
		className="flex-row items-center self-start overflow-hidden rounded-full px-3.5 py-2"
		style={{ gap: 7, backgroundColor: 'rgba(255,255,255,0.15)' }}
	>
		{/* The mark is sized to the caps, and the caps (which ride high in their box) are nudged
		    down a point, so mark, word and pill share one centre line. */}
		<Glyph name={glyph} size={15} color={colors.white} />
		<Header variant="h7" tone="white" style={{ marginTop: 1 }}>
			{label}
		</Header>
	</BlurView>
)

/**
 * The pair the home card wears, whichever of its two states it is in.
 *
 * They were on the empty card only, which made the two states look like different components
 * sitting in one slot. They are what Wally is rather than what this member has booked, so they
 * belong to the card rather than to the visit — and a booked card that keeps them is the same
 * object with different words in it.
 */
export const HomeBadges = () => (
	<View className="absolute left-[14px] top-[14px] flex-row" style={{ gap: 6 }}>
		<PhotoBadge glyph="asterisk" label="Painless cleanings" />
		<PhotoBadge glyph="cross" label="Swiss tech" />
	</View>
)
